import { EmailDeliveriesFilters } from "@ac-expo/api-types";

export const emailDeliveriesQueryKeys = {
  all: ["email-deliveries"] as const,
  list: (filters: EmailDeliveriesFilters) =>
    [
      ...emailDeliveriesQueryKeys.all,
      filters.eventId,
      filters.orderId,
      filters.recipient,
      filters.status,
      filters.pageIndex,
      filters.pageSize,
    ] as const,
  events: (emailDeliveryId: string) =>
    [...emailDeliveriesQueryKeys.all, emailDeliveryId, "events"] as const,
};

export default emailDeliveriesQueryKeys;
